"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/direct-insert-borrowing-base-report/types");
const v4_1 = require("zod/v4");
exports.artifactType = 'directInsertBorrowingBaseReport';
const BaseDbNodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: v4_1.z.literal(exports.artifactType),
    externalFilename: v4_1.z.null(),
    loanProductSlug: v4_1.z.null(),
    creditFacilitySlug: v4_1.z.string(),
});
exports.IntermediateNodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.IntermediateNodeSchema = BaseDbNodeTypeSchema.extend({
    configuration: types_1.IntermediateRecordConfigSchema,
});
// *** Db Configuration ***
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema.extend({
    cashResponseTapeArtifactSlug: v4_1.z.string().optional().nullable(),
});
// *** Db Record ***
exports.NodeTypeSchema = BaseDbNodeTypeSchema.extend({
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map